import { generatePath, useNavigate, useParams } from "react-router";
import AppPage from "layouts/AppPage";
import { INTERNAL_TEAM_ROUTES } from "definitions/constants/routeConstants";
import { useEffect } from "react";
import { useNavbar } from "hooks/useNavbar";
import KickOff from "features/PendingNewHire/KickOff";
import { FormStatusProvider } from "contexts/FormStatusContext";
import { Divider, Stack } from "@chakra-ui/react";
import { useNewHireJourneyDetailQuery } from "features/NewHireJourney/hooks";
import NewHireHeader from "features/NewHireJourney/Components/NewHireHeader";

export default function PendingNewHireJourneyPage() {
  const { id } = useParams<{ id: string }>();
  const { setBackLocationPath, setBackLocationName, setPageTitle } = useNavbar();
  const navigate = useNavigate();

  const { data: newHireJourney, isLoading } = useNewHireJourneyDetailQuery(id);

  useEffect(() => {
    if (newHireJourney && !isLoading) {
      if (newHireJourney.isPending === false) {
        navigate(generatePath(INTERNAL_TEAM_ROUTES.newHireJourneys.show, { id }));
      }
      setPageTitle(`New Hire ${newHireJourney?.newHire?.fullName}`);
      // setBackLocationName("Home");
      // setBackLocationPath("/");
    }
    return () => {
      setPageTitle(null);
      setBackLocationName(null);
      setBackLocationPath(null);
    };
  }, [id, isLoading, navigate, newHireJourney, setBackLocationName, setBackLocationPath, setPageTitle]);

  return (
    <AppPage display="flex" flexDirection="column">
      <FormStatusProvider>
        <Stack mt="3" mb="1" flexShrink={0}>
          <Divider />
          <NewHireHeader my="2" mx="4" newHireJourney={newHireJourney} />
          <Divider />
        </Stack>
        <KickOff newHireJourneyId={id as string} />
      </FormStatusProvider>
    </AppPage>
  );
}
